export const CHOOSE_PRODUCT_ESSENTIAL_EVENT_UA = ["clicked", "Product_essential", "Choose_product_CTA"] as const;
export const CHOOSE_PRODUCT_COMPLETE_EVENT_UA = ["clicked", "Product_complete", "Choose_product_CTA"] as const;
